var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"taskIndicators"}},[_c('div',{staticClass:"ss-chart"},[_c('DomeEchartWrap',{ref:"cProduct",staticClass:"canvas-wrap",attrs:{"id":"c-product"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }